module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tooltip":{"account":"Selecionar Conta"},"status":{"test":"Teste","inactive":"Inativo","blocked":"Bloqueado","active":"Ativo"}},"en-US":{"tooltip":{"account":"Select Account"},"status":{"test":"Test","inactive":"Inactive","blocked":"Blocked","active":"Active"}}}')
  delete Component.options._Ctor
}
